import React from "react";
import { Item } from "@functions-types";
import { Chip } from "@mui/material";
import { makeStyles } from "@providers/Mui";

type ItemCardProps = {
  item: Item | null;
};

const useStyles = makeStyles((theme) => ({
  root: {
    display: "inline-block",
    borderRadius: 5,
    fontWeight: 500,
    backgroundColor: "rgb(226, 226, 226)",
    color: "rgb(82, 82, 82)",
    height: 24,
    lineHeight: "24px",
    padding: theme.spacing(0, 1),
    whiteSpace: "nowrap",
  },
}));

export const ItemCard: React.FC<ItemCardProps> = ({ item }) => {
  const classes = useStyles();
  return (
    <span className={classes.root}>{item?.name ?? "N/A"}</span>
  );
};
